import { fontSize, fontWeight, lineHeight } from '@ardoq/design-tokens';

export const header1 = `
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.x4large};
  line-height: ${lineHeight.x2large};
  letter-spacing: -0.5px;
`;

export const header2 = `
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.x2large};
  line-height: ${lineHeight.xlarge};
`;

export const header3 = `
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.xlarge};
  line-height: ${lineHeight.large};
`;

export const HEADER4_LINE_HEIGHT_IN_PIXELS = 20;
export const header4 = `
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.large};
  line-height: ${lineHeight.regular};
`;

export const header5 = `
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize.small};
  line-height: ${lineHeight.small};
  text-transform: uppercase;
`;

export const text1 = `
  font-weight: ${fontWeight.regular};
  font-size: ${fontSize.large};
  line-height: ${lineHeight.regular};
`;

export const text1Italic = `
  ${text1};
  font-style: italic;
`;

export const text1Bold = `
  ${text1};
  font-weight: ${fontWeight.bold};
`;

export const text2 = `
  font-weight: ${fontWeight.regular};
  font-size: ${fontSize.regular};
  line-height: ${lineHeight.regular};
`;

export const text2Bold = `
  ${text2}
  font-weight: ${fontWeight.bold};
`;

export const caption = `
  font-weight: ${fontWeight.regular};
  font-size: ${fontSize.small};
  line-height: ${lineHeight.small};
`;

export const captionBold = `
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.small};
  line-height: ${lineHeight.small};
`;

export const typographyMixins = {
  header1,
  header2,
  header3,
  header4,
  header5,
  text1,
  text1Italic,
  text1Bold,
  text2,
  text2Bold,
  caption,
  captionBold,
};

export type TypographyMixins = keyof typeof typographyMixins;
